var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeech2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 127.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 1.218,
    y: -0.133,
    x: -0.109,
    height: 1.267,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.455
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      filter: "url(#a)",
      fill: "#7a7a7a"
    },
    d: "M381.88 200.52c-1.108 0-2 .823-2 1.844v16.812c0 1.02.892 1.844 2 1.844h1.188c-.442 1.945-1.394 3.82-2.313 5.687 2.365-1.627 4.148-3.4 5.688-5.687h23.437c1.108 0 2-.823 2-1.844v-16.812c0-1.021-.892-1.844-2-1.844h-28z",
    transform: "translate(-1448.31 -758.14) scale(3.8479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinejoin: "round",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.25988,
      fill: "#fff"
    },
    d: "M380.62 198.38c-1.108 0-2 .823-2 1.844v16.812c0 1.02.892 1.844 2 1.844h1.188c-.442 1.945-1.394 3.82-2.313 5.687 2.365-1.627 4.148-3.4 5.688-5.687h23.437c1.108 0 2-.823 2-1.844v-16.812c0-1.021-.892-1.844-2-1.844h-28z",
    transform: "translate(-1448.31 -758.14) scale(3.8479)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech2);
export default __webpack_public_path__ + "static/media/speech2.ccbaba09cfca057c78712401dc03d727.svg";
export { ForwardRef as ReactComponent };